import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Copy, Check } from "lucide-react"
import { cn } from "@/lib/utils"

interface JsonViewerProps {
  data: unknown
  maxHeight?: string
}

export function JsonViewer({ data, maxHeight = "400px" }: JsonViewerProps) {
  const [copied, setCopied] = useState(false)

  if (data === null || data === undefined) {
    return (
      <p className="text-muted-foreground text-sm">No data</p>
    )
  }

  const formatted = JSON.stringify(data, null, 2)

  function handleCopy() {
    navigator.clipboard.writeText(formatted)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon-sm"
        className="absolute top-2 right-2 z-10"
        onClick={handleCopy}
      >
        {copied ? <Check className="size-4" /> : <Copy className="size-4" />}
      </Button>
      <div
        className={cn("bg-muted overflow-auto rounded-md p-4")}
        style={{ maxHeight }}
      >
        <pre className="text-sm">
          <code className="font-mono">{formatted}</code>
        </pre>
      </div>
    </div>
  )
}
